import { render, staticRenderFns } from "./AbkAnswer.vue?vue&type=template&id=3165d760&scoped=true&"
import script from "./AbkAnswer.vue?vue&type=script&lang=js&"
export * from "./AbkAnswer.vue?vue&type=script&lang=js&"
import style0 from "./AbkAnswer.vue?vue&type=style&index=0&id=3165d760&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165d760",
  null
  
)

export default component.exports